/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { date, DateFormat, entity } from '@gh/core-data';
import { ItemsListItemDto } from './items-list-item.dto';

export const ItemsListItemMapper = entity<ItemsListItemDto>({
  costUpdated: date(DateFormat.DateTime),
});
